import { VisitAndAppointmentStatus } from '@dreryk/egabinet-visit-frontend-api';

import { useBoolean } from '@dreryk/react-common';

import { PreInterviewPreviewModal } from './PreInterviewPreviewModal';

type PreInterviewPreviewModalOpenerRenderProps = { openModal: VoidFunction };
type PreInterviewPreviewModalOpenerProps = {
   readonly children: (renderProps: PreInterviewPreviewModalOpenerRenderProps) => JSX.Element;
   readonly appointmentId: number;
   readonly beginDate: Date;
   readonly endDate: Date;
   readonly patientId: number;
   readonly patientFullName: string;
   readonly visitId: number | undefined;
   readonly visitStatus: VisitAndAppointmentStatus;
};

export const PreInterviewPreviewModalOpener = (props: PreInterviewPreviewModalOpenerProps): JSX.Element => {
   const [{ setFalse: closeModal, setTrue: openModal }, modalOpened] = useBoolean(false);

   return (
      <>
         {props.children({
            openModal: openModal,
         })}

         {modalOpened ? (
            <PreInterviewPreviewModal
               appointmentId={props.appointmentId}
               beginDate={props.beginDate}
               endDate={props.endDate}
               patientFullName={props.patientFullName}
               patientId={props.patientId}
               onClose={closeModal}
               visitId={props.visitId}
               visitStatus={props.visitStatus}
            />
         ) : null}
      </>
   );
};
